import * as types from './action_types';
import WordService from '../../services/word_service';
import WordMapper from '../utils/word_mapper';

export const newest = (limit = 3) => {
  return async(dispatch) => {
    try {
      dispatch({ type: types.NEWEST_WORDS_RETRIEVING });
      const newestWordsData = await WordService.newest(limit);
      const newestWords = []
      for (let trendingWord of newestWordsData) {
        newestWords.push(WordMapper.map(trendingWord));
      }
      dispatch({ type: types.NEWEST_WORDS_RETRIEVED, newestWords });
    } catch(error) {
      dispatch({ type: types.TRENDING_RETRIEVAL_ERROR, error });
    }
  }
}

export const mostTacked = (limit = 3) => {
  return async(dispatch) => {
    try {
      dispatch({ type: types.MOST_TACKED_WORDS_RETRIEVING });
      const mostTackedWordsData = await WordService.mostTacked(limit);
      const mostTackedWords = []
      for (let mostTackedWord of mostTackedWordsData) {
        mostTackedWords.push(WordMapper.map(mostTackedWord));
      }
      dispatch({ type: types.MOST_TACKED_WORDS_RETRIEVED, mostTackedWords });
    } catch(error) {
      dispatch({ type: types.TRENDING_RETRIEVAL_ERROR, error });
    }
  }
}



// WEBPACK FOOTER //
// ./src/stores/trends/actions.js